import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit, Renderer2 } from '@angular/core'

import { CartService, ICartGroup } from '../../../services/cart.service'
import { RoutingPathService } from '../../../services/environment.service'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-cart-counter',
  templateUrl: './bmcore-cart-counter.component.html',
  styleUrls: ['./bmcore-cart-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCartCounterComponent implements OnInit {
  @Input() appType: AppType

  lg: LgType
  showCartPopup = false
  currencySign: CurrencySignType
  cartGroups: Array<ICartGroup> = []

  checkoutPage: string

  constructor(
    private i18nService: I18nService,
    private cartService: CartService,
    private renderer: Renderer2,
    private routingPathService: RoutingPathService
  ) {
    this.checkoutPage = this.routingPathService.getCheckoutUrl()
  }

  ngOnInit(): void {
    this.getFullBeats()
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
    this.cartService.addSubscriber('group-updated', this.changedCart.bind(this))
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeCartPopup()
    }
  }

  getFullBeats() {
    this.cartService.getFullBeats().then(() => this.cartService.checkPayments())
  }

  changedCart() {
    this.cartGroups = this.cartService.groups.getGroups()
  }

  closeCartPopup() {
    this.showCartPopup = false
    this.renderer.removeClass(document.body, 'modal-open')
  }

  openCartPopup() {
    this.showCartPopup = true
    this.renderer.addClass(document.body, 'modal-open')
  }
}
